import { AvailableUpdateDetail } from './available-update-detail.model';

export class AvailableUpdate {
	public status: number;
	public updateList: AvailableUpdateDetail[];
}
